import React, { Fragment } from 'react';
import walking1 from '../../../images/walking1.png';
import walking2 from '../../../images/walking2.png';
import walking3 from '../../../images/walking3.png';
import walking4 from '../../../images/walking4.png';
import walking5 from '../../../images/walking5.png';
import walking6 from '../../../images/walking6.png';
import walking7 from '../../../images/walking7.png';
import walking8 from '../../../images/walking8.png';
import walking9 from '../../../images/walking9.png';

import './driveFaqImg.css';

const AccessByWalkNYC = () => (
  <Fragment>
    <div>
      <img
        className="faq-image-compress"
        src={walking9}
        alt="Parking Lot"
      />
      <p>Enter the parking lot through the main entrance on 46th Ave.</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking1}
        alt="Parking Lot"
      />
      <p>Turn left to enter door 1C and walk down the hallway</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking2}
        alt="Parking Lot"
      />
      <p>Turn right and take the door to the stairwell</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking3}
        alt="Parking Lot"
      />
      <p>Take the stairwell up one level</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking4}
        alt="Parking Lot"
      />
      <p>and exit through the door labelled “Parking Garage”</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking5}
        alt="Parking Lot"
      />
      <img
        className="faq-image-compress"
        src={walking6}
        alt="Parking Lot"
      />
      <p>
        Turn left immediately as you exit the door and walk down the ramp
        to the elevator lobby in the far corner.
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking7}
        alt="Parking Lot"
      />
      <p>Take the elevator up to Floor 6</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking8}
        alt="Parking Lot"
      />
      <p>
        Exit the elevator and walk directly ahead to the Autzu parking
        signage
      </p>
    </div>
  </Fragment>
);

export default AccessByWalkNYC;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccessByWalkNYC.js